import { Expertise } from '@/shared/types/stylist';

export const REASON_OPTIONS = [
  { label: 'No Preference', value: 'NO PREFERENCE' },
  { label: 'Big & Tall Dressing', value: Expertise.BIG_TALL },
  { label: 'Black Tie & Red Carpet Events', value: Expertise.BLACK_TIE },
  { label: 'Bridal Styling', value: Expertise.BRIDAL },
  { label: 'Capsule Wardrobe Building', value: Expertise.CAPSULE_WARDROBE },
  { label: 'Carry-On Only Styling', value: Expertise.CARRY_ON },
  {
    label: 'Closet Edit & Organization',
    value: Expertise.CLOSET_EDIT,
  },
  {
    label: 'Date Night Looks',
    value: Expertise.DATE_NIGHT,
  },
  {
    label: 'Destination-Specific Styling',
    value: Expertise.DESTINATION,
  },
  {
    label: 'Editorial & Photoshoot Styling',
    value: Expertise.EDITORIAL,
  },
  { label: 'Everyday Styling', value: Expertise.EVERYDAY },
  {
    label: 'Maternity & Postpartum',
    value: Expertise.MATERNITY,
  },
  {
    label: 'Modest Styling',
    value: Expertise.MODEST,
  },
  { label: 'Petite Styling', value: Expertise.PETITE },
  { label: 'Plus Size Styling', value: Expertise.PLUS_SIZE },
  { label: 'Sport & Leisure Styling', value: Expertise.SPORT },
  {
    label: 'Street Style Looks',
    value: Expertise.STREET_STYLE,
  },
  {
    label: 'Vintage Dressing',
    value: Expertise.VINTAGE,
  },
  { label: 'TV, Film, Media Wardrobe', value: Expertise.TV_FILM_MEDIA },
  { label: 'Vacation & Resort Wear', value: Expertise.VACATION },
  { label: 'Wedding Guest Styling', value: Expertise.WEDDING_GUEST },
  { label: 'Workwear & Power Dressing', value: Expertise.WORK_OUTFITS },
];

export const CALENDAR_MONTH_FORMAT = 'yyyy-MM';
export const CALENDAR_DAY_FORMAT = 'yyyy-MM-dd';
export const CALENDAR_MONTH_FORMAT_DISPLAY = 'MMMM yyyy';
export const PRE_AUTH_DURATION_BUFFER = 30;
export const IN_PERSON_SESSION_MAX_DURATION_MINUTES = 480; // 8 hours maximum
/** Stripe hold multiplier for in-person sessions (e.g. 2hr booking → 3hr hold). */
export const IN_PERSON_SESSION_PRE_AUTH_MULTIPLIER = 1.5;
